import { render, staticRenderFns } from "./ownerDetailRepair.vue?vue&type=template&id=845e7e74"
import script from "./ownerDetailRepair.vue?vue&type=script&lang=js"
export * from "./ownerDetailRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports